// @ts-nocheck
import { useEffect, useState } from "react";
import { apiFetchInit } from "@/legacy/helpersModule";

export function HrNotificationEmailBanner({ requestType }) {
  const [emails, setEmails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/hr-notification-email", apiFetchInit())
      .then((r) => (r.ok ? r.json() : { emails: [], configured: false }))
      .then((d) => setEmails(Array.isArray(d.emails) ? d.emails : []))
      .catch(() => setEmails([]))
      .finally(() => setLoading(false));
  }, []);

  const requestLabel = requestType === "reattempt" ? "reattempt" : "reschedule";

  return (
    <div className="max-w-3xl mx-auto px-6 pt-4">
      <div className="bg-sky-50 border border-sky-200 rounded-xl px-4 py-3 text-sm text-sky-900">
        <p className="font-bold text-xs uppercase tracking-wide text-sky-700 mb-1">
          Email alerts sent to
        </p>
        {loading ? (
          <p className="text-sky-700">Loading…</p>
        ) : emails?.length ? (
          <p className="font-semibold break-all">{emails.join(", ")}</p>
        ) : (
          <p className="text-amber-800 font-semibold">
            Not configured — set HR_NOTIFICATION_EMAIL in backend .env
          </p>
        )}
        <p className="text-xs text-sky-700 mt-1.5">
          {requestLabel.charAt(0).toUpperCase() + requestLabel.slice(1)} requests
          trigger an email to this address (from backend .env).
        </p>
      </div>
    </div>
  );
}
